import styled from 'styled-components';
import { Grid } from '@mui/material';
import Typography from '../../../atoms/Typography';

export const MessageBubble = styled(Typography)`
  background-color: ${({ theme, isSender }) =>
    theme && (isSender ? theme.secondary.dark : theme.blueGrey[400])};
  padding: 0.7rem;
  border-radius: 1rem;
  max-width: 80%;
  color: ${({ theme }) => theme && theme.secondary.contrastText};

  ${({ isSender }) =>
    isSender ? `    border-bottom-right-radius: 0;` : `    border-bottom-left-radius: 0;`}
`;

export const MessageForm = styled(Grid)`
  margin-top: 2rem;
`;
